import React from "react";
import { Building2 } from "lucide-react";
import { formatCurrency } from "../../../utils/function";
import { TopFundedOrg } from "../../../views/global-admin-pages/dashboard/types";

const RANK_STYLES = [
  "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400", // 1st
  "bg-slate-200 text-slate-600 dark:bg-gray-700 dark:text-gray-300", // 2nd
  "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-400", // 3rd
];

// Same "cpas design" frosted card language as ChannelPerformance — a ranked
// list rather than a table since there's only one metric (wallet balance) to
// show per org, not several columns to compare.
const TopFundedOrgs: React.FC<{ orgs: TopFundedOrg[] }> = ({ orgs }) => {
  if (!orgs || orgs.length === 0) return null;

  return (
    <div className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm rounded-2xl border border-slate-200 dark:border-gray-700 shadow-sm overflow-hidden">
      <div className="px-6 pt-6 pb-4">
        <h3 className="text-lg font-semibold text-slate-800 dark:text-gray-100">Top Funded Organizations</h3>
        <p className="text-sm text-slate-500 dark:text-gray-400 mt-1">
          Organizations with the highest wallet balances across the platform.
        </p>
      </div>
      <div className="divide-y divide-slate-100 dark:divide-gray-800">
        {orgs.map((org, i) => (
          <div key={org.org_id} className="flex items-center gap-3 px-6 py-3.5">
            <span
              className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-xs font-bold ${
                RANK_STYLES[i] || "bg-slate-100 text-slate-500 dark:bg-gray-800 dark:text-gray-400"
              }`}
            >
              {i + 1}
            </span>
            <span className="w-9 h-9 rounded-lg bg-slate-100 dark:bg-gray-800 flex items-center justify-center shrink-0">
              <Building2 className="w-4 h-4 text-slate-500 dark:text-gray-400" />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-slate-800 dark:text-gray-100 truncate">{org.name || "—"}</p>
              {/* <p className="text-xs text-slate-400 dark:text-gray-500 truncate font-mono">{org.org_id}</p> */}
            </div>
            <p className="text-sm font-semibold text-slate-800 dark:text-gray-100 shrink-0 whitespace-nowrap">
              {formatCurrency(org.wallet_balance, "NGN", "symbol")}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopFundedOrgs;
